export const DOCS = "/docs";

export const AUTHERIZATION = "/docs/authorization";
export const SDK = "/docs/sdk";
export const PRODUCT_MARKETPLACE_SDK = "/docs/sdk/productMarketplace";
export const PIXEL = "/docs/pixel";
export const EMBEDEDCODE = "/docs/embededCode";
export const APIINTEGRATION = "/docs/apiIntegration";
export const EMBEDDEDREWARD = "/docs/embededCode/rewards";

export const AUTHERIZATION_LINK = "/docs/authorization/:id?";
export const SDK_LINK = "/docs/sdk/:id?";
export const PIXEL_LINK = "/docs/pixel/:id?";
export const EMBEDEDCODE_LINK = "/docs/embededCode/:id?";
export const APIINTEGRATION_LINK = "/docs/apiIntegration/:id?";

export const GAMIFICATION_LINK = "/docs/gamification";

// image upload
export const FILE_UPLOAD_LINK = "/docs/fileUpload";
